import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { GROUP_ROUTE } from "../../data/routerConstants";
import Delete from "../common/delete";
import Edit from "../common/edit";
import MatTable from "../common/matTable";

const GroupsTable = ({ data, sortColumn, onSort, onDelete }) => {
  const { t } = useTranslation(["group"]);
  const columns = [
    { path: "id", label: t("ID") },
    {
      path: "name",
      label: t("Name"),
      cardHeader:true,
      sort: true,
    },
    { path: "phone", label: t("Phone") },
    { path: "addressLine1", label: t("Address") },
    {
      key: "action",
      content: (item) => {
        return <Edit link={`${GROUP_ROUTE}/${item.id}`}/>;
      },
    }
  ];

  return (
    <MatTable
      data={data}
      columns={columns}
      sortColumn={sortColumn}
      onSort={onSort}
    />
  );
};

export default GroupsTable;
